import { render, staticRenderFns } from "./FormVolumeAlert.vue?vue&type=template&id=d67cf76c&lang=pug"
import script from "./FormVolumeAlert.vue?vue&type=script&lang=js"
export * from "./FormVolumeAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports